import { Button, Card, Col, Row, Spinner } from 'react-bootstrap'
import * as dayjs from 'dayjs'
import { useState, useEffect, useContext } from 'react'
import { Formik, Field, Form, getIn, FieldArray } from 'formik'
import * as Yup from 'yup'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { AuthContext } from '../AuthContext'
import axios from 'axios'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

const BloodPressureCard = ({
  yesterday,
  edit,
  setEdit,
  patient_id,
  lastWeek,
}) => {
  const [dayList, setDayList] = useState([])
  const [isCardLoading, setIsCardLoading] = useState(false)
  const { baseUrl, sendDiscordNotification, currentUser, extendCookie } =
    useContext(AuthContext)
  const [bloodPressureList, setbloodPressureList] = useState([])
  const getBloodPressure = '/api/crm/patient/measure/getBloodPressure'

  useEffect(() => {
    if (currentUser && currentUser.session) {
      let loadingTimer

      loadingTimer = setTimeout(() => {
        // setIsCardLoading(true)
      }, 500)

      axios
        .post(
          baseUrl + getBloodPressure,
          {
            patient_id: patient_id,
            start_date: lastWeek.format('YYYY-MM-DD'),
            end_date: yesterday.add(1, 'day').format('YYYY-MM-DD'),
          },
          {
            headers: {
              'Content-Type': 'application/json; charset=UTF-8',
              Accept: '*/*',
              session: currentUser.session,
            },
          }
        )
        .then((res) => {
          if (res.data.data) {
            console.log('getBloodPressure', res.data)
            setbloodPressureList(res.data.data)
            extendCookie()
          }
        })
        .catch((e) => {
          console.log('getBloodPressure error', e)
          sendDiscordNotification(`getBloodPressure Error \n Error: ${e} `)
          alert('伺服器忙線中，請稍後再試')
        })
        .finally(() => {
          // setIsCardLoading(false)
          clearTimeout(loadingTimer)
        })
    }
  }, [currentUser, yesterday, edit])

  // error classname
  function getClassName(errors, touched, fieldName) {
    const isError = getIn(errors, fieldName) && getIn(touched, fieldName)
    return isError ? 'border border-danger border-2' : ''
  }

  // error message
  function renderErrorMessage(errors, touched, fieldName) {
    const isError = getIn(errors, fieldName) && getIn(touched, fieldName)
    const errorMessage = getIn(errors, fieldName)
    return isError ? <div className="error-message">{errorMessage}</div> : null
  }

  // 整理數據
  useEffect(() => {
    let newDaylist = []
    for (let dayCount = 0; dayCount < 7; dayCount++) {
      newDaylist.push({
        date: yesterday.subtract(dayCount, 'day').format('YYYY-MM-DD ddd'),
        data: { day: [], night: [] },
      })
    }

    // 映射數據到newDaylist
    bloodPressureList.forEach((record) => {
      const recordDate = record.record_time.split(' ')[0]
      const recordTime = record.record_time.split(' ')[1]
      const dateObject = newDaylist.find(
        (dateObj) => dateObj.date.split(' ')[0] === recordDate
      )

      if (dateObject) {
        // 分早晚
        if (recordTime < '12:01:00') {
          dateObject.data.day.push(record)
        } else {
          dateObject.data.night.push(record)
        }
      }
    })
    newDaylist.forEach((dateObject) => {
      dateObject.data.day.sort((a, b) =>
        a.record_time.localeCompare(b.record_time)
      )
      dateObject.data.night.sort((a, b) =>
        a.record_time.localeCompare(b.record_time)
      )
    })

    setDayList(newDaylist)
    console.log('newDaylist', newDaylist)
    // console.log('bloodPressureList', bloodPressureList)
  }, [yesterday, bloodPressureList])

  const borderGreen = { outline: '#67c7aa 1px solid' }

  const bloodPressureSchema = Yup.object().shape({
    records: Yup.array().of(
      Yup.object().shape({
        sbp: Yup.number()
          .required('收縮壓為必填項目')
          .positive('收縮壓必須為正數')
          .min(50, '收縮壓最低為 50')
          .max(350, '收縮壓最高為 350'),
        dbp: Yup.number()
          .required('舒張壓為必填項目')
          .positive('舒張壓必須為正數')
          .min(30, '舒張壓最低為 30')
          .max(200, '舒張壓最高為 200'),
      })
    ),
    // .required('血壓記錄為必填項目')
    // .min(4, '至少需要四條血壓記錄'),
  })
  dayjs.extend(utc)
  // 啟用對時區的支持
  dayjs.extend(timezone)
  // 編輯血壓
  const initialRecords = [
    {
      recordTime: dayjs().tz('Asia/Taipei').startOf('day').toDate(),
      sbp: '',
      dbp: '',
      comment: '',
    },
  ]

  // const [records, setRecords] = useState(initialRecords)
  // console.log('records', records)
  // // 添加新记录
  // const addRecord = () => {
  //   setRecords([...records, { ...initialRecord }])
  // }

  // // 删除指定记录
  // const deleteRecord = (index) => {
  //   setRecords(records.filter((_, i) => i !== index))
  // }
  const addBloodPressure = '/api/crm/patient/measure/addBloodPressure'
  // 格式化records為API期望的格式
  const formatRecordsForApi = (records) => {
    return records.map(({ recordTime, sbp, dbp, comment }) => ({
      record_time: dayjs(recordTime).format('YYYY-MM-DD HH:mm:ss'),
      sbp: parseInt(sbp, 10),
      dbp: parseInt(dbp, 10),
      comment,
    }))
  }
  const handleSubmit = (values) => {
    const requestBody = {
      patient_id: patient_id,
      blood_pressure: formatRecordsForApi(values.records),
    }
    console.log('handleSubmit', values)
    console.log('requestbody', requestBody)
    if (currentUser && currentUser.session) {
      let loadingTimer

      loadingTimer = setTimeout(() => {
        setIsCardLoading(true)
      }, 500)

      axios
        .post(baseUrl + addBloodPressure, requestBody, {
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
            Accept: '*/*',
            session: currentUser.session,
          },
        })
        .then((res) => {
          if (res.data.message === '新增成功') {
            console.log('addBloodPressure', res.data)
            extendCookie()
          }
        })
        .catch((e) => {
          console.log('addBloodPressure error', e)
          sendDiscordNotification(`addBloodPressure Error \n Error: ${e} `)
          alert('伺服器忙線中，請稍後再試')
        })
        .finally(() => {
          setIsCardLoading(false)
          clearTimeout(loadingTimer)
          setTimeout(() => {
            setEdit({ isEditing: false, date: '' })
          }, 100)
        })
    }
  }

  return (
    <>
      {/* 顯示的卡片 */}
      {!edit.isEditing &&
        dayList.map((day, i) => {
          return (
            <Card
              key={i}
              style={{ width: '75%' }}
              className="bloodPressureCard mb-4"
            >
              <Card.Header
                className="text-white d-flex justify-content-between align-items-center h6"
                style={{ backgroundColor: '#67c7aa' }}
              >
                {day.date}
                <Button
                  variant="light"
                  style={{ color: '#67c7aa' }}
                  onClick={() => {
                    setEdit({ isEditing: true, date: day.date.split(' ')[0] })
                  }}
                >
                  新增
                </Button>
              </Card.Header>
              <Card.Body className="p-0">
                <div className="d-flex flex-column">
                  {/* 早 */}
                  <Row>
                    <Col xs={3} className="p-0">
                      <div
                        className="d-flex w-100 p-2 h-100 align-items-center"
                        style={borderGreen}
                      >
                        <div className="w-100 d-flex justify-content-center align-items-center fw-bold h5 m-0">
                          {/* <div
                            className="text-dark bg-warning h5 rounded d-flex align-items-center justify-content-center"
                            style={{ width: '35px', height: '35px' }}
                          > */}
                          早{/* </div> */}
                        </div>
                      </div>
                    </Col>

                    <Col xs={9} className="d-flex flex-column p-0">
                      {day.data.day && day.data.day.length > 0 ? (
                        day.data.day.map((record, i) => {
                          return (
                            <Row
                              key={i}
                              className="w-100 d-flex align-items-center
                        justify-content-center"
                              style={borderGreen}
                            >
                              <Col className="p-0">
                                <div
                                  className="h5 text-center p-2 m-0"
                                  style={{
                                    borderRight: '#67c7aa 2px solid',
                                  }}
                                >
                                  {record.record_time
                                    .split(' ')[1]
                                    .slice(0, 5) || '-'}
                                </div>
                              </Col>
                              <Col>
                                <div
                                  className={`h5 text-center p-2 m-0 ${record.sbp > 130 ? 'text-danger' : ''}`}
                                >
                                  {record.sbp || '-'}
                                </div>
                              </Col>
                              /
                              <Col
                                style={{
                                  borderRight: '#67c7aa 2px solid',
                                }}
                              >
                                <div
                                  className={`h5 text-center p-2 m-0 ${record.dbp > 85 ? 'text-danger' : ''}`}
                                >
                                  {record.dbp || '-'}
                                </div>
                              </Col>
                              <Col className="p-0">
                                <div className="h6 text-center p-2 m-0">
                                  {record.comment || '-'}
                                </div>
                              </Col>
                            </Row>
                          )
                        })
                      ) : (
                        <Row
                          className="w-100 d-flex align-items-center
                        justify-content-center"
                          style={borderGreen}
                        >
                          <Col className="p-0">
                            <div
                              className="h5 text-center p-2 m-0"
                              style={{
                                borderRight: '#67c7aa 2px solid',
                              }}
                            >
                              -
                            </div>
                          </Col>
                          <Col>
                            <div className="h5 text-center p-2 m-0">-</div>
                          </Col>
                          /
                          <Col
                            style={{
                              borderRight: '#67c7aa 2px solid',
                            }}
                          >
                            <div className="h5 text-center p-2 m-0">-</div>
                          </Col>
                          <Col className="p-0">
                            <div className="h6 text-center p-2 m-0">-</div>
                          </Col>
                        </Row>
                      )}
                    </Col>
                  </Row>
                  {/* 晚 */}
                  <Row>
                    <Col xs={3} className="p-0">
                      <div
                        className="d-flex w-100 p-2 h-100 align-items-center"
                        style={borderGreen}
                      >
                        <div className="w-100 d-flex justify-content-center align-items-center fw-bold h5 m-0">
                          晚
                        </div>
                      </div>
                    </Col>

                    <Col xs={9} className="d-flex flex-column p-0">
                      {day.data.night && day.data.night.length > 0 ? (
                        day.data.night.map((record, i) => {
                          return (
                            <Row
                              key={i}
                              className="w-100 d-flex align-items-center
                        justify-content-center"
                              style={borderGreen}
                            >
                              <Col className="p-0">
                                <div
                                  className="h5 text-center p-2 m-0"
                                  style={{
                                    borderRight: '#67c7aa 2px solid',
                                  }}
                                >
                                  {record.record_time
                                    .split(' ')[1]
                                    .slice(0, 5) || '-'}
                                </div>
                              </Col>
                              <Col>
                                <div
                                  className={`h5 text-center p-2 m-0 ${record.sbp > 130 ? 'text-danger' : ''}`}
                                >
                                  {record.sbp || '-'}
                                </div>
                              </Col>
                              /
                              <Col
                                style={{
                                  borderRight: '#67c7aa 2px solid',
                                }}
                              >
                                <div
                                  className={`h5 text-center p-2 m-0 ${record.dbp > 85 ? 'text-danger' : ''}`}
                                >
                                  {record.dbp || '-'}
                                </div>
                              </Col>
                              <Col className="p-0">
                                <div className="h6 text-center p-2 m-0">
                                  {record.comment || '-'}
                                </div>
                              </Col>
                            </Row>
                          )
                        })
                      ) : (
                        <Row
                          className="w-100 d-flex align-items-center
                        justify-content-center"
                          style={borderGreen}
                        >
                          <Col className="p-0">
                            <div
                              className="h5 text-center p-2 m-0"
                              style={{
                                borderRight: '#67c7aa 2px solid',
                              }}
                            >
                              -
                            </div>
                          </Col>
                          <Col>
                            <div className="h5 text-center p-2 m-0">-</div>
                          </Col>
                          /
                          <Col
                            style={{
                              borderRight: '#67c7aa 2px solid',
                            }}
                          >
                            <div className="h5 text-center p-2 m-0">-</div>
                          </Col>
                          <Col className="p-0">
                            <div className="h6 text-center p-2 m-0">-</div>
                          </Col>
                        </Row>
                      )}
                    </Col>
                  </Row>
                  {/* <div
                    className="p-3"
                    style={{ borderTop: '#67c7aa 2px solid' }}
                  >
                    備註：
                  </div> */}
                </div>
              </Card.Body>
            </Card>
          )
        })}

      {/* 編輯的卡片 */}
      {edit.isEditing && (
        <Formik
          initialValues={{ records: initialRecords }}
          validationSchema={bloodPressureSchema}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            console.log(values)
            handleSubmit(values)
            setSubmitting(true)
            setTimeout(() => {
              resetForm()
              setSubmitting(false)
            }, 5000)
          }}
        >
          {({ errors, touched, isSubmitting, values, setFieldValue }) => (
            <Form className="w-100 d-flex justify-content-center">
              <Card
                style={{
                  width: '75%',
                  marginBottom: '45vh',
                  overflow: 'visible',
                }}
                className="bloodPressureCard"
              >
                <Card.Header
                  className="text-white d-flex justify-content-between align-items-center h6"
                  style={{ backgroundColor: '#67c7aa' }}
                >
                  {edit.date}
                  <div>
                    <Button
                      variant="outline-light"
                      className="text-white me-2"
                      type="button"
                      onClick={() => {
                        setEdit({ isEditing: false, date: '' })
                      }}
                    >
                      取消
                    </Button>
                    <Button
                      variant="light"
                      type="submit"
                      style={{ color: '#67c7aa' }}
                      disabled={isSubmitting}
                    >
                      儲存
                      <Spinner
                        as="span"
                        animation={isCardLoading ? 'border' : ''}
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    </Button>
                  </div>
                </Card.Header>
                <Card.Body className="p-0">
                  <FieldArray name="records">
                    {({ push, remove }) => (
                      <>
                        {values.records.length > 0 &&
                          values.records.map((record, index) => (
                            <Row key={index}>
                              <Col xs={3} style={borderGreen}>
                                <div className="form-section mt-2 ms-4 d-flex align-items-center">
                                  <DatePicker
                                    className="w-75 me-3"
                                    selected={values.records[index].recordTime}
                                    onChange={(date) => {
                                      const combinedDateTime = dayjs(edit.date)
                                        .tz('Asia/Taipei')
                                        .set('hour', dayjs(date).hour())
                                        .set('minute', dayjs(date).minute())
                                        .set('second', dayjs(date).second())
                                        .toDate()
                                      setFieldValue(
                                        `records[${index}].recordTime`,
                                        combinedDateTime
                                      )
                                    }}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={15}
                                    timeCaption="time"
                                    dateFormat="HH:mm"
                                    timeFormat="HH:mm"
                                  />
                                </div>
                              </Col>
                              <Col xs={6} className="d-flex flex-column p-0">
                                <div
                                  className="w-100 d-flex align-items-center justify-content-center p-2"
                                  style={borderGreen}
                                >
                                  <div className="h5 text-center w-50">
                                    <Field
                                      placeholder="收縮壓"
                                      name={`records[${index}].sbp`}
                                      type="number"
                                      className={
                                        (errors.records?.[index]?.sbp &&
                                        touched.records?.[index]?.sbp
                                          ? 'is-invalid'
                                          : '') + ' w-75'
                                      }
                                    />
                                    {errors.records?.[index]?.sbp &&
                                      touched.records?.[index]?.sbp && (
                                        <div className="text-danger">
                                          {errors.records[index].sbp}
                                        </div>
                                      )}
                                  </div>
                                  /
                                  <div className="h5 text-center w-50">
                                    <Field
                                      placeholder="舒張壓"
                                      name={`records[${index}].dbp`}
                                      type="number"
                                      className={
                                        (errors.records?.[index]?.dbp &&
                                        touched.records?.[index]?.dbp
                                          ? 'is-invalid'
                                          : '') + ' w-75'
                                      }
                                    />
                                    {errors.records?.[index]?.dbp &&
                                      touched.records?.[index]?.dbp && (
                                        <div className="text-danger">
                                          {errors.records[index].dbp}
                                        </div>
                                      )}
                                  </div>
                                </div>
                              </Col>
                              <Col
                                xs={3}
                                style={borderGreen}
                                className="d-flex"
                              >
                                <div className="form-section mt-2">
                                  <Field
                                    placeholder="備註可留空"
                                    name={`records[${index}].comment`}
                                    type="text"
                                    className="w-75"
                                  />
                                </div>
                                {index > 0 && (
                                  <Button
                                    size="sm"
                                    className="mt-3"
                                    variant="danger"
                                    style={{ height: 'fit-content' }}
                                    onClick={() => remove(index)}
                                  >
                                    <i class="fa-solid fa-trash-can" />
                                  </Button>
                                )}
                              </Col>
                            </Row>
                          ))}
                        <Card.Footer
                          className="text-white text-center h6 mb-0"
                          style={{
                            backgroundColor: '#67c7aa',
                            cursor: 'pointer',
                          }}
                          onClick={() =>
                            push({
                              recordTime: dayjs()
                                .tz('Asia/Taipei')
                                .startOf('day')
                                .toDate(),
                              sbp: '',
                              dbp: '',
                              comment: '',
                            })
                          }
                        >
                          + 新增一筆
                        </Card.Footer>
                      </>
                    )}
                  </FieldArray>
                </Card.Body>
              </Card>
            </Form>
          )}
        </Formik>
      )}
    </>
  )
}

export default BloodPressureCard
